<template>
    <ToolButton :Editor="Editor" KnownIcon="H5" @ToolClick="Editor.chain().focus().toggleHeading({level:1}).run()" 
        :class="{ 'toggled': Editor.isActive('heading', { level: 5 }) }">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>